import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ToastService } from '../../../main/services/toast';
import { TENDER_STEPS, Tender } from '../../models/tender';
import { TenderService } from '../../services';

@Component({
    selector: 'jft-create-tender-steps',
    templateUrl: './create-tender-steps.component.html',
    styleUrls: ['./create-tender-steps.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateTenderStepsComponent implements OnInit, OnDestroy {

    public tender: Tender;
    public stepsCompleted = 0;

    public detailsLink: string;
    public contractsLink: string;
    public suppliersLink: string;
    public reviewLink: string;

    public tenderSteps = TENDER_STEPS;
    private routerSubscribtion: Subscription;
    public currentRouteUrl: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private service: TenderService,
        private toast: ToastService,
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.tender = data['tender'];

        this.detailsLink = `/tenders/new/${this.tender.id}/details`;
        this.contractsLink = `/tenders/new/${this.tender.id}/locations`;
        this.suppliersLink = `/tenders/new/${this.tender.id}/suppliers`;
        this.reviewLink = `/tenders/new/${this.tender.id}/review`;

        this.currentRouteUrl = this.router.url;
        this.stepsCompleted = this.getStepsCompleted();

      this.routerSubscribtion = this.router.events.pipe(filter((event) => {
        return event instanceof NavigationEnd;
      })).subscribe((params: any) => {
            this.currentRouteUrl = params.url;
            this.stepsCompleted = this.getStepsCompleted();
        });
    }

    private getStepsCompleted() {
        switch (this.tender.stepCompleted) {
            case TENDER_STEPS.DETAILS:
                return 0;
            case TENDER_STEPS.CONTRACTS:
                return 1;
            case TENDER_STEPS.SUPPLIERS:
                return 2;
            case TENDER_STEPS.LAUNCH:
                return 3;
        }
    }

    public goToStep(step) {
        this.service.goToStep(this.tender, step)
            .subscribe((data) => {
                this.router.navigateByUrl(this.getStepLink(step));
            }, (e) => {
            this.toast.error(e);
            });
    }

    private getStepLink(step) {
        switch (step) {
            case TENDER_STEPS.DETAILS:
                return this.detailsLink;
            case TENDER_STEPS.CONTRACTS:
                return this.contractsLink;
            case TENDER_STEPS.SUPPLIERS:
                return this.suppliersLink;
            case TENDER_STEPS.LAUNCH:
                return this.reviewLink;
        }
    }

    public isCurrentLink(step) {
        let stepLink = this.getStepLink(step);
        return stepLink == this.currentRouteUrl;
    }

    public ngOnDestroy(): void {
        this.routerSubscribtion?.unsubscribe();
    }
}
